import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import SVGLogoPulinetFull from '@/assets/img/logo/logo-pulinet-full.svg';

import { AUTHENTICATE, SET_PROFILE } from '@/core/store/types/action-types';
import userClient from '@/core/api/user-service';
import { LoginDTO } from '@/../client-generator/generated-clients/user';
import AppChangePassword from '@/views/components/AppChangePasswordModal/AppChangePassword.vue';

@Component({
  components: {
    SVGLogoPulinetFull,
    AppChangePassword,
  },
})
export default class Login extends Vue {
  isLoading = false;
  userIsWrongRoleWarning = false;
  showPasswordDialog = false;
  passwordExpiredSecurityCode: string | null = null;

  formModel = {
    username: '',
    password: '',
  };

  get formRules() {
    const required = {
      required: true,
      message: this.$t('validation.fieldRequired'),
    };

    return {
      username: required,
      password: required,
    };
  }

  get versionNumber() {
    return `v${this.$config.FRONTEND_VERSION}`;
  }

  submit() {
    const $form = this.$refs.theForm as Form;

    $form.validate(async (isValid) => {
      if (isValid) {
        this.isLoading = true;

        try {
          const token = await userClient.login({
            username: this.formModel.username,
            password: this.formModel.password,
          } as LoginDTO);
          await this.$store.dispatch(AUTHENTICATE, {
            token,
            authState: true,
          });
          const profile = await userClient.me();
          this.$store.dispatch(SET_PROFILE, profile);

          this.$router.replace('/');
        } catch (error) {
          let messageError: string | null = 'error';
          switch (error.status) {
            case 401:
              messageError = null;
              this.userIsWrongRoleWarning = true;
              break;
            case 403:
              messageError = this.$t('apiErrors.forbidden').toString();
              break;
            case 404:
              messageError = this.$t('userLoginError').toString();
              break;
            case 419:
              this.showPasswordDialog = true;
              this.passwordExpiredSecurityCode = error.response;
              return;
            default:
              messageError = this.$t('apiErrors.serverError').toString();
          }
          if (messageError != null) {
            this.$message.error(messageError);
          }
        } finally {
          this.isLoading = false;
        }
      }
    });
  }

  goToRecoverPassword() {
    this.$router.push({
      name: 'page-recover-password',
    });
  }

  clearWarnings() {
    this.userIsWrongRoleWarning = false;
    const $form = this.$refs.theForm as Form;
    $form.resetFields();
  }
}
